import App from '../../containers/App'
import Home from '../../containers/home/Home'

export default () => {
  return [
    {
      component: App,
      routes: [
        {
          path: '/home',
          exact: true,
          component: Home
        },
        {
          path: '/',
          component: Home
        }
      ]
    }
  ]
}
